import { render, staticRenderFns } from "./CreateGroupLog.vue?vue&type=template&id=47fceada&lang=pug&"
import script from "./CreateGroupLog.vue?vue&type=script&lang=ts&"
export * from "./CreateGroupLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports